import React from 'react'
import PropTypes from 'prop-types'

import Footer from 'components/footer/footer'
import Navbar from 'components/navbar/navbar'
import { Helmet } from 'react-helmet'

const Layout = ({ children, hasFooter = true, hasNav = true }) => {
  const isDevelopment = process.env.NODE_ENV === 'development'
  return (
    <div className="flex min-h-screen flex-col justify-between">
      <div>
        {hasNav ? <Navbar className="fixed" /> : null}
        <div style={{ paddingTop: hasNav ? 84 : 0 }}>{children}</div>
      </div>
      {isDevelopment && (
        <Helmet>
          <script>
            {`var MessageBirdChatWidgetSettings = {     widgetId: '501858c5-f14c-4689-b9cc-e1551c6529f8',     initializeOnLoad: true,   };  !function(){"use strict";if(Boolean(document.getElementById("live-chat-widget-script")))console.error("MessageBirdChatWidget: Snippet loaded twice on page");else{var e,t;window.MessageBirdChatWidget={},window.MessageBirdChatWidget.queue=[];for(var i=["init","setConfig","toggleChat","identify","hide","on","shutdown"],n=function(){var e=i[d];window.MessageBirdChatWidget[e]=function(){for(var t=arguments.length,i=new Array(t),n=0;n<t;n++)i[n]=arguments[n];window.MessageBirdChatWidget.queue.push([[e,i]])}},d=0;d<i.length;d++)n();var a=(null===(e=window)||void 0===e||null===(t=e.MessageBirdChatWidgetSettings)||void 0===t?void 0:t.widgetId)||"",o=function(){var e,t=document.createElement("script");t.type="text/javascript",t.src="https://livechat.messagebird.com/bootstrap.js?widgetId=".concat(a),t.async=!0,t.id="live-chat-widget-script";var i=document.getElementsByTagName("script")[0];null==i||null===(e=i.parentNode)||void 0===e||e.insertBefore(t,i)};"complete"===document.readyState?o():window.attachEvent?window.attachEvent("onload",o):window.addEventListener("load",o,!1)}}();`}
          </script>
        </Helmet>
      )}
      {hasFooter ? <Footer /> : null}
    </div>
  )
}

Layout.propTypes = {
  children: PropTypes.element,
  hasFooter: PropTypes.bool,
  hasNav: PropTypes.bool
}
export default Layout
